module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0173.jpg?v=1897204d";